import React, { FC, ReactNode, createContext, useCallback, useContext, useState } from 'react';
import MobileAuthModal from './MobileAuthModal';

// Lets any screen or action prompt for login with the shared bottom sheet
// instead of silently redirecting home. The provider is mounted only in the
// mobile layout, so on web the hook returns null and callers keep their
// existing web behavior.
const AuthSheetContext = createContext<(() => void) | null>(null);

export const useAuthSheet = (): (() => void) | null => useContext(AuthSheetContext);

export const AuthSheetProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openSheet = useCallback(() => setOpen(true), []);

  return (
    <AuthSheetContext.Provider value={openSheet}>
      {children}
      <MobileAuthModal open={open} onClose={() => setOpen(false)} />
    </AuthSheetContext.Provider>
  );
};
